import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=26ff81e6&scoped=true&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"
import style0 from "./assets/css/hope-ui.min.css?v=2.0.0?vue&type=style&index=0&prod&lang=css&"
import style1 from "./assets/css/pro.min.css?v=2.0.0?vue&type=style&index=1&prod&lang=css&"
import style2 from "./assets/css/custom.min.css?v=2.0.0?vue&type=style&index=2&prod&lang=css&"
import style3 from "./assets/css/dark.min.css?v=2.0.0?vue&type=style&index=3&prod&lang=css&"
import style4 from "./assets/css/customizer.min.css?v=2.0.0?vue&type=style&index=4&prod&lang=css&"
import style5 from "./assets/css/rtl.min.css?v=2.0.0?vue&type=style&index=5&prod&lang=css&"
import style6 from "./Register.css?vue&type=style&index=6&id=26ff81e6&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ff81e6",
  null
  
)

export default component.exports